import { supabase } from "@/integrations/supabase/client";

interface StripePaymentMetadata {
  travel_request_id: string; // UUID
  user_id: string; // UUID
  itinerary_id: string; // UUID
  customer_email?: string | null;
}

interface CreateStripePaymentLinkParams {
  itineraryId: string;
  travelRequestId: string;
  itineraryTitle: string;
  itineraryTotal?: number | null;
  userId: string; // UUID
  customerEmail?: string | null;
  /** Stripe Express account ID of the agency (acct_xxxxx). When provided, the charge goes to the agency with a 3% platform fee. */
  agencyStripeAccountId?: string | null;
}

export const createStripePaymentLink = async ({
  itineraryId,
  travelRequestId,
  itineraryTitle,
  itineraryTotal,
  userId,
  customerEmail,
  agencyStripeAccountId,
}: CreateStripePaymentLinkParams): Promise<string> => {
  // Costruisci metadata Stripe con solo UUID
  const metadata: StripePaymentMetadata = {
    travel_request_id: travelRequestId,
    user_id: userId,
    itinerary_id: itineraryId,
    customer_email: customerEmail ?? null,
  };

  const totalCents = Math.round((Number(itineraryTotal) || 0) * 100);
  // Piattaforma trattiene 3% del totale come application fee
  const platformFeeCents = agencyStripeAccountId
    ? Math.round(totalCents * 0.03)
    : undefined;

  console.log("Creating Stripe payment link with metadata:", metadata);

  const payload: Record<string, unknown> = {
    line_items: [
      {
        price_data: {
          currency: "eur",
          product_data: {
            name: itineraryTitle,
            description: "Trip Quote",
          },
          unit_amount: totalCents,
        },
        quantity: 1,
      },
    ],
    metadata,
    // Connect fields (included only when agency account is provided)
    ...(agencyStripeAccountId
      ? {
          agency_stripe_account_id: agencyStripeAccountId,
          application_fee_amount: platformFeeCents,
        }
      : {}),
  };

  const { data, error } = await supabase.functions.invoke("create-stripe-link", {
    body: payload,
  });

  if (error) {
    throw new Error(error.message);
  }

  const stripeData = data as { url?: string } | null;
  if (!stripeData?.url) {
    throw new Error("Stripe payment link was not returned");
  }

  return stripeData.url;
};